import React, { useState, useEffect } from "react";
import Layout from '../components/layout/Layout';
import API from '../utils/api';
import { useNavigate } from "react-router-dom";

const Chatbot = () => {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([
    { type: "bot", text: "Hi there! I'm your AI mental health assistant. How can I help you today?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔐 Redirect if not logged in
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/login");
    }
  }, [navigate]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;
  
    const userMessage = { type: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setLoading(true);
  
    try {
      const res = await API.post("/api/chatbot", { message: input }); // ⬅️ use API
      const botReply = { type: "bot", text: res.data.reply };
      setMessages((prev) => [...prev, botReply]);
    } catch (err) {
      console.error("❌ Chatbot error:", err);
      setMessages((prev) => [...prev, { type: "bot", text: "Sorry, something went wrong." }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container py-5">
        <h2 className="text-center mb-4">AI Support Chatbot 🤖</h2>
        <div className="border p-4 rounded" style={{ maxHeight: "400px", overflowY: "auto" }}>
          {messages.map((msg, index) => (
            <div key={index} className={`mb-2 d-flex ${msg.type === "user" ? "justify-content-end" : "justify-content-start"}`}>
              <div
                className={`p-2 rounded text-white ${msg.type === "user" ? "bg-primary" : "bg-secondary"}`}
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  maxWidth: "75%",
                }}
              >
                {msg.text}
              </div>
            </div>
          ))}
          {loading && (
            <div className="text-muted small">Typing...</div>
          )}
        </div>

        <form className="mt-3 d-flex gap-2" onSubmit={handleSend}>
          <input
            className="form-control"
            placeholder="Ask me anything..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <button className="btn btn-primary" type="submit">
            <i className="fas fa-paper-plane"></i>
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default Chatbot;
